/* ── MOBILE MENU ── */
  function toggleMenu() {
    const btn = document.getElementById('hamburger');
    const panel = document.getElementById('mobile-panel');
    btn.classList.toggle('open');
    panel.classList.toggle('open');
    document.body.style.overflow = panel.classList.contains('open') ? 'hidden' : '';
  }
  function closeMenu() {
    document.getElementById('hamburger').classList.remove('open');
    document.getElementById('mobile-panel').classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ── SCROLL REVEAL ── */
  function revealOnScroll() {
    document.querySelectorAll('.reveal:not(.visible)').forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 1.1) el.classList.add('visible');
    });
  }
  window.addEventListener('scroll', revealOnScroll, { passive: true });
  // Fire multiple times to catch any layout shifts
  revealOnScroll();
  requestAnimationFrame(revealOnScroll);
  setTimeout(revealOnScroll, 300);
  setTimeout(revealOnScroll, 800);

  /* ── STAGGERED CARDS ── */
  const io = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const kids = entry.target.querySelectorAll('.stagger-child');
      kids.forEach((kid, i) => setTimeout(() => kid.classList.add('visible'), i * 100));
      io.unobserve(entry.target);
    });
  }, { threshold: 0.05 });
  document.querySelectorAll('.collections-grid, .products-grid').forEach(el => io.observe(el));

  /* ── SCROLL PROGRESS BAR ── */
  const progressBar = document.getElementById('scroll-progress');
  if (progressBar) {
    window.addEventListener('scroll', () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      progressBar.style.width = (window.scrollY / total * 100) + '%';
    }, { passive: true });
  }

  /* ── NAV SHRINK ON SCROLL ── */
  const navWrap = document.querySelector('.nav-wrap');
  window.addEventListener('scroll', () => {
    if (navWrap) navWrap.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });

  /* ══════════════════════════════════════════════════════
     SLIDESHOW ENGINE
     Shopify migration: each slideshow becomes a
     themed-slideshow.liquid section with metafield images.
     ══════════════════════════════════════════════════════ */

  // Collect all slide images for shared lightbox
  const allSlides = [];
  document.querySelectorAll('.slideshow-slide').forEach((slide, i) => {
    slide._globalIdx = allSlides.length;
    allSlides.push({ src: slide.querySelector('img').src, alt: slide.querySelector('img').alt });
    slide.addEventListener('click', () => openLightbox(slide._globalIdx));
  });

  /* ── PER-SLIDESHOW CAROUSEL ── */
  function initSlideshow(trackId, dotsId) {
    const track = document.getElementById(trackId);
    if (!track) return;
    const slides = track.querySelectorAll('.slideshow-slide');
    const dotsContainer = document.getElementById(dotsId);
    const section = track.closest('.slideshow-section');
    const prevBtn = section.querySelector('.slideshow-prev');
    const nextBtn = section.querySelector('.slideshow-next');

    let current = 0;

    function perView() {
      const w = window.innerWidth;
      if (w <= 480) return 1;
      if (w <= 768) return 2;
      if (w <= 1100) return 3;
      return 4;
    }

    function maxIndex() { return Math.max(0, slides.length - perView()); }

    function slideWidth() {
      if (!slides[0]) return 0;
      return slides[0].offsetWidth + 10; // 10px gap
    }

    function goTo(idx) {
      current = Math.max(0, Math.min(idx, maxIndex()));
      track.style.transform = `translateX(${-(current * slideWidth())}px)`;
      dotsContainer.querySelectorAll('.slideshow-dot').forEach((d, i) => {
        d.classList.toggle('active', i === current);
      });
    }

    // Build dots
    const numDots = maxIndex() + 1;
    dotsContainer.innerHTML = '';
    for (let i = 0; i < numDots; i++) {
      const dot = document.createElement('button');
      dot.className = 'slideshow-dot' + (i === 0 ? ' active' : '');
      dot.addEventListener('click', () => goTo(i));
      dotsContainer.appendChild(dot);
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    // Touch/swipe
    let touchStartX = 0;
    track.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) goTo(dx < 0 ? current + 1 : current - 1);
    });

    window.addEventListener('resize', () => goTo(Math.min(current, maxIndex())));
    goTo(0);
  }

  // Init all 4 slideshows
  initSlideshow('track-diablo', 'dots-diablo');
  initSlideshow('track-muzzle', 'dots-muzzle');
  initSlideshow('track-field',  'dots-field');
  initSlideshow('track-rev',    'dots-rev');

  /* ── LIGHTBOX ── */
  let lightboxIndex = 0;

  function openLightbox(index) {
    lightboxIndex = index;
    updateLightbox();
    document.getElementById('lightbox').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    document.getElementById('lightbox').classList.remove('open');
    document.body.style.overflow = '';
  }

  function updateLightbox() {
    const slide = allSlides[lightboxIndex];
    document.getElementById('lightboxImg').src = slide.src;
    document.getElementById('lightboxImg').alt = slide.alt;
    document.getElementById('lightboxCounter').textContent = `${lightboxIndex + 1} / ${allSlides.length}`;
    const cap = document.getElementById('lightboxCaption');
    if (cap) cap.textContent = slide.alt || '';
  }

  document.getElementById('lightboxClose').addEventListener('click', closeLightbox);
  document.getElementById('lightboxPrev').addEventListener('click', () => {
    lightboxIndex = (lightboxIndex - 1 + allSlides.length) % allSlides.length;
    updateLightbox();
  });
  document.getElementById('lightboxNext').addEventListener('click', () => {
    lightboxIndex = (lightboxIndex + 1) % allSlides.length;
    updateLightbox();
  });
  document.getElementById('lightbox').addEventListener('click', e => {
    if (e.target === e.currentTarget) closeLightbox();
  });
  document.addEventListener('keydown', e => {
    const lb = document.getElementById('lightbox');
    if (!lb.classList.contains('open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft')  document.getElementById('lightboxPrev').click();
    if (e.key === 'ArrowRight') document.getElementById('lightboxNext').click();
  });

  /* ── PARALLAX HERO ── */
  const heroImg = document.querySelector('.hero-image img');
  if (heroImg) {
    window.addEventListener('scroll', () => {
      heroImg.style.transform = 'translateY(' + (window.scrollY * 0.15) + 'px) scale(1.08)';
    }, { passive: true });
    heroImg.style.transform = 'scale(1.08)';
  }

  /* ── SPOTLIGHT CURSOR ── */
  const spotlight = document.getElementById('spotlight');
  if (spotlight) {
    document.addEventListener('mousemove', e => {
      spotlight.style.left = e.clientX + 'px';
      spotlight.style.top  = e.clientY + 'px';
    });
  }

  /* ── CART ── */
  let cartCount = 0;
  function cartClick() {
    alert('Cart coming soon — connect your Shopify store to activate checkout!');
  }
  function addToCart(btn) {
    cartCount++;
    const badge = document.querySelector('.cart-badge');
    if (badge) badge.textContent = cartCount;
    const orig = btn.textContent;
    btn.textContent = '\u2713 Added!';
    btn.style.background = '#8f1414';
    setTimeout(() => { btn.textContent = orig; btn.style.background = ''; }, 2000);
  }
  function notifyMe(btn) {
    const orig = btn.textContent;
    btn.textContent = "\u2713 We'll notify you!";
    btn.style.background = '#444';
    setTimeout(() => { btn.textContent = orig; btn.style.background = ''; }, 3000);
  }

  /* ── NEWSLETTER ── */
  function handleNewsletter(e) {
    e.preventDefault();
    const btn = e.target.querySelector('button');
    btn.textContent = "You're in! \u2713";
    btn.style.background = '#8f1414';
    setTimeout(() => { btn.textContent = 'Subscribe'; btn.style.background = ''; e.target.reset(); }, 3000);
  }

  /* \u2550\u2550 CURSOR DOT \u2550\u2550 */
  const cursorDot = document.createElement('div');
  cursorDot.className = 'cursor-dot';
  document.body.appendChild(cursorDot);
  const cursorGlow = document.createElement('div');
  cursorGlow.className = 'cursor-glow';
  document.body.appendChild(cursorGlow);
  let cx = -300, cy = -300, glowX = -300, glowY = -300;
  document.addEventListener('mousemove', e => {
    cx = e.clientX; cy = e.clientY;
    cursorDot.style.left = cx + 'px'; cursorDot.style.top = cy + 'px';
  });
  (function animGlow() {
    glowX += (cx - glowX) * 0.07; glowY += (cy - glowY) * 0.07;
    cursorGlow.style.left = glowX + 'px'; cursorGlow.style.top = glowY + 'px';
    requestAnimationFrame(animGlow);
  })();
  document.querySelectorAll('a, button, .collection-tile, .product-card, .slideshow-slide, .dog-chip').forEach(el => {
    el.addEventListener('mouseenter', () => cursorDot.classList.add('hovering'));
    el.addEventListener('mouseleave', () => cursorDot.classList.remove('hovering'));
  });
  document.addEventListener('touchstart', () => { cursorDot.style.opacity='0'; cursorGlow.style.opacity='0'; }, {passive:true});

  /* \u2550\u2550 MAGNETIC BUTTONS \u2550\u2550 */
  document.querySelectorAll('.btn-primary, .btn-outline, .btn-cream, .slideshow-btn').forEach(btn => {
    btn.addEventListener('mousemove', e => {
      const r = btn.getBoundingClientRect();
      const dx = e.clientX - (r.left + r.width/2);
      const dy = e.clientY - (r.top + r.height/2);
      btn.style.transform = `translate(${dx*.22}px,${dy*.22}px)`;
    });
    btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
  });

  /* \u2550\u2550 3D TILT \u2014 Collection tiles \u2550\u2550 */
  document.querySelectorAll('.collection-tile').forEach(tile => {
    tile.addEventListener('mouseenter', () => { tile.style.transition = 'transform .1s ease'; });
    tile.addEventListener('mousemove', e => {
      const r = tile.getBoundingClientRect();
      const x = (e.clientX - r.left)/r.width - 0.5;
      const y = (e.clientY - r.top)/r.height - 0.5;
      tile.style.transform = `perspective(700px) rotateY(${x*12}deg) rotateX(${-y*12}deg) scale(1.025)`;
    });
    tile.addEventListener('mouseleave', () => {
      tile.style.transition = 'transform .55s ease';
      tile.style.transform = '';
    });
  });

  /* \u2550\u2550 SLIDESHOW SLIDE micro-parallax \u2550\u2550 */
  document.querySelectorAll('.slideshow-slide').forEach(slide => {
    slide.addEventListener('mousemove', e => {
      const r = slide.getBoundingClientRect();
      const x = (e.clientX - r.left)/r.width - 0.5;
      const y = (e.clientY - r.top)/r.height - 0.5;
      const img = slide.querySelector('img');
      if (img) img.style.transform = `scale(1.07) translate(${x*-10}px,${y*-10}px)`;
    });
    slide.addEventListener('mouseleave', () => {
      const img = slide.querySelector('img');
      if (img) img.style.transform = '';
    });
  });

  /* \u2550\u2550 STAT COUNT-UP on entry \u2550\u2550 */
  const statObs = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (!en.isIntersecting) return;
      statObs.unobserve(en.target);
      const el = en.target;
      const target = parseInt(el.dataset.count || '0', 10);
      if (!target) return;
      const finalHTML = el.innerHTML; // capture exact final state before any changes
      const isK    = finalHTML.includes('K');
      const isPct  = finalHTML.includes('%');
      const isPlus = finalHTML.includes('+') && !isK;
      const duration = 1600;
      const startTime = performance.now();
      (function tick(now) {
        const t = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - t, 3); // ease-out cubic
        const val = Math.round(eased * target);
        if (isK) {
          // data-count="176" => animates 0->176, displayed as 0.0K -> 17.6K
          const whole = Math.floor(val / 10);
          const dec   = val % 10;
          el.innerHTML = '<span class=\"stat-accent\">' + whole + '</span>.' + dec + 'K';
        } else if (isPct) {
          el.innerHTML = val + '<span class=\"stat-accent\">%</span>';
        } else if (isPlus) {
          el.innerHTML = val + '<span class=\"stat-accent\">+</span>';
        } else {
          el.textContent = val;
        }
        if (t < 1) {
          requestAnimationFrame(tick);
        } else {
          el.innerHTML = finalHTML; // restore pixel-perfect original
          el.animate([
            {transform:'scale(1)'},
            {transform:'scale(1.12)'},
            {transform:'scale(1)'}
          ], {duration:420, easing:'cubic-bezier(.34,1.56,.64,1)'});
        }
      })(startTime);
    });
  }, {threshold:0.6});
  document.querySelectorAll('.stat-num').forEach(n => statObs.observe(n));

  /* ── FAILSAFE REVEAL — ensures all animated elements become visible ── */
  /* In case IntersectionObserver is slow, reveal everything after 1.5s */
  setTimeout(function() {
    document.querySelectorAll('.reveal:not(.visible)').forEach(function(el) {
      el.classList.add('visible');
    });
    document.querySelectorAll('.stagger-child:not(.visible)').forEach(function(el, i) {
      setTimeout(function() { el.classList.add('visible'); }, i * 60);
    });
  }, 1500);

  /* ── SIZE SELECTOR PILLS ── */
  document.querySelectorAll('.size-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      document.querySelectorAll('.size-pill').forEach(p => p.classList.remove('selected'));
      pill.classList.add('selected');
    });
  });

  /* ── BACK TO TOP ── */
  const backToTop = document.getElementById('backToTop');
  if (backToTop) {
    window.addEventListener('scroll', () => {
      backToTop.classList.toggle('visible', window.scrollY > 700);
    }, { passive: true });
  }

  /* ── STICKY CTA BAR ── */
  const stickyCta = document.getElementById('stickyCta');
  const heroWrap  = document.querySelector('.hero-video-wrap');
  if (stickyCta && heroWrap) {
    window.addEventListener('scroll', () => {
      const heroBottom = heroWrap.getBoundingClientRect().bottom;
      stickyCta.classList.toggle('visible', heroBottom < 0);
    }, { passive: true });
  }

(function(){
  var PASSCODE = 'TRONC101';

  window.openHandlerModal = function(){
    var m = document.getElementById('handler-modal');
    m.style.display = 'flex';
    setTimeout(function(){ document.getElementById('handler-code').focus(); }, 80);
  };

  window.closeHandlerModal = function(){
    document.getElementById('handler-modal').style.display = 'none';
    document.getElementById('handler-code').value = '';
    document.getElementById('handler-error').style.opacity = '0';
  };

  window.checkHandlerCode = function(){
    var val = document.getElementById('handler-code').value.trim().toUpperCase();
    var err = document.getElementById('handler-error');
    if(val === PASSCODE){
      window.location.href = '/collections/canine-access';
    } else {
      err.style.opacity = '1';
      var inp = document.getElementById('handler-code');
      inp.style.borderColor = '#b91c1c';
      inp.value = '';
      setTimeout(function(){ err.style.opacity='0'; inp.style.borderColor='rgba(185,28,28,0.35)'; }, 2200);
    }
  };

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){
      var m = document.getElementById('handler-modal');
      if(m && m.style.display !== 'none') window.closeHandlerModal();
    }
  });
})();